// TripPreview.js
import React, {useState} from 'react';
import TripDetailsModal from './TripCard';
import './TripPreview.css';
import {Avatar, AvatarGroup} from '@mui/material';
import Rating from '@mui/material/Rating';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import {Icons} from '../data/Icons';
import ClickableAvatar from './ClickableAvatar';
import {Button} from './Button';


const TripPreview = ({
                         trip,
                         showProfile = true,
                         showMoreInfoLink = false,
                         hideDate = false,
                         compactModal = false,
                         suggestionMode = false,
                         onSelectTrip,
                         currentUserId,       // the logged-in user
                         tripCreatorId,       // the user that create the trip
                         onAfterCancel,       // callback to refresh after cancel
                         isJoining            // whether the user is joining or not
                     }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [rating, setRating] = useState(null);

    const handleOpenModal = () => {
        setIsOpen(true);
    };

    const handleCloseModal = (didCancel) => {
        setIsOpen(false);
        if (didCancel && typeof onAfterCancel === 'function') {
            onAfterCancel();
        }
    };

    // Parse trip date from "6.5.25"
    const parseTripDate = (dateStr) => {
        const [day, month, year] = dateStr.split('.').map(Number);
        const fullYear = year < 100 ? 2000 + year : year;
        return new Date(fullYear, month - 1, day);
    };

    // Format to "dd/mm/yyyy"
    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const tripDateObj = trip.timestamp?.toDate?.() ?? new Date(); // fallback to now
    const formattedDate = formatDate(tripDateObj);
    const isFutureTrip = tripDateObj > new Date();
    const isPastTrip = tripDateObj < new Date();

    return (
        <>
            <div
                className={`trip-preview ${compactModal ? 'compact' : ''} ${suggestionMode ? 'suggestion' : ''}`}
                dir="rtl"
                onClick={handleOpenModal}
                style={{cursor: 'pointer', position: 'relative'}}
            >
                <img src={trip.image} alt={trip.title} className="trip-preview-img"/>

                {showMoreInfoLink && trip.moreInfoUrl && (
                    <a
                        href={trip.moreInfoUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="trip-more-details"
                        onClick={(e) => e.stopPropagation()}
                    >
                        למידע נוסף
                    </a>
                )}

                <div className="trip-preview-content">
                    <h3 className="trip-title">{trip.title}</h3>
                    <p className="trip-cat">{Icons.style} <strong>סגנון:</strong> {trip.style}</p>
                    {!hideDate && (
                        <p className="trip-cat">
                            {Icons.date} <strong>מתי:</strong> {formattedDate} {Icons.time} {trip.time}
                        </p>
                    )}
                    <p className="trip-cat">
                        {Icons.suitableFor} <strong>מתאים ל:</strong> {trip.forWhom}
                    </p>
                    <p className="trip-details">
                        {Icons.difficulty} <strong>רמת קושי:</strong> {trip.difficulty} |
                        {Icons.duration} <strong> משך:</strong> {trip.duration} |
                        {Icons.location} <strong>אזור:</strong> {trip.location}
                    </p>


                    {showProfile && (
                        <div className="trip-participants">
                            <AvatarGroup spacing="medium" max={3}>
                                {trip.participants.map((id, idx) => (
                                    <ClickableAvatar id={id} key={idx}/>
                                ))}
                            </AvatarGroup>
                        </div>
                    )}
                </div>

                {suggestionMode && onSelectTrip && currentUserId === tripCreatorId && (
                    <div className="select-button-inside">
                        <Button
                            text="בחר"
                            onClick={(e) => {
                                e.stopPropagation();
                                onSelectTrip(trip.id);
                            }}
                        />
                    </div>
                )}

                {/* Join again button for cancelled trips */}
                {trip.status === 'cancelled' && (
                    <md-filled-tonal-button
                        className="join-again-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            alert('הצטרפת מחדש לטיול!');
                        }}
                    >
                        הצטרף מחדש
                    </md-filled-tonal-button>
                )}

                {/*/!* ❤️ Rating for past trips *!/*/}
                {/*{isPastTrip && (*/}
                {/*    <div className="trip-rating" onClick={(e) => e.stopPropagation()}>*/}
                {/*        <Rating*/}
                {/*            name={`trip-rating-${trip.id}`}*/}
                {/*            value={rating}*/}
                {/*            onChange={(event, newValue) => {*/}
                {/*                setRating(newValue);*/}
                {/*            }}*/}
                {/*            icon={<FavoriteIcon fontSize="inherit"/>}*/}
                {/*            emptyIcon={<FavoriteBorderIcon fontSize="inherit"/>}*/}
                {/*            sx={{color: 'red'}}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*)}*/}
            </div>

            <TripDetailsModal
                isOpen={isOpen}
                onClose={handleCloseModal}
                onAfterCancel={onAfterCancel}
                trip={trip}
                compact={compactModal}
                hideCancelButton={compactModal}
                isJoining={isJoining}
            />
        </>
    );
};

export default TripPreview;
